/**
 * AzureIcon — two-tone Azure logo (brief blues #50b0f0 / #2f7fd0), sized by the
 * caller's `className`. Shared by the connection form's "Browse Azure…" button
 * and the first-run empty-state "Import from Azure" card.
 */
export function AzureIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 96 96" className={className} aria-hidden="true" focusable="false">
      <path
        fill="#50b0f0"
        d="M33.34 6.54h26.04L31.35 86.63a4.15 4.15 0 0 1-3.93 2.82H8.15a4.15 4.15 0 0 1-3.93-5.47L29.4 9.37a4.15 4.15 0 0 1 3.94-2.83z"
      />
      <path
        fill="#2f7fd0"
        d="M71.18 60.26H30.99a1.91 1.91 0 0 0-1.31 3.31l25.82 24.09a4.17 4.17 0 0 0 2.85 1.12h23.4z"
      />
      <path
        fill="#50b0f0"
        d="M33.34 6.54a4.12 4.12 0 0 0-3.94 2.88L4.25 83.97a4.14 4.14 0 0 0 3.9 5.48h20.88a4.44 4.44 0 0 0 3.42-2.9l5.01-14.77 17.91 16.7a4.24 4.24 0 0 0 2.67.97H81.65L71.12 60.26H40.42z"
      />
    </svg>
  );
}
